module.exports = __webpack_public_path__ + "img/Transportierte_Person.a8e105f5.svg";